createDomainEntity.$inject = ['graph']
export default function createDomainEntity(graph) {
  return {
    restrict: 'EA',
    scope: {
      onDomainCreated: '&',
      domainNames: '='
    },
    template: require('./_createDomainEntity.html'),
    link: function(scope) {
      scope.domainEditInfo = {}

      // error handling
      scope.errorMessage = ''
      scope.showError = false

      scope.savingDomain = false
      scope.createDomain = function(data) {
        data.name = data.name.trim()

        // check if the name exists already
        if (scope.domainNames && scope.domainNames.indexOf(data.name) > -1) {
          scope.showError = true
          scope.errorMessage = 'Name "' + data.name + '" already exists.'
          return
        }
        scope.savingDomain = true
        scope.showError = false
        graph.createDomain(data.name).then(
          function(createdDomain) {
            scope.onDomainCreated({ domain: createdDomain })
            scope.savingDomain = false
          },
          function(reason) {
            scope.errorMessage = 'There was an error creating the domain. ' + reason
            scope.showError = true
            scope.savingDomain = false
          }
        )
      }
    }
  }
}
